import { AfterViewChecked, Directive, ElementRef, Input } from '@angular/core'

@Directive({
  selector: '[busy-button]',
  standalone: false,
})
export class BusyButtonDirective implements AfterViewChecked {
  @Input() busy = false
  @Input() done = false
  @Input('glyph-size') glyphSize = '1.1rem'
  private initialized = false
  private originalInnerHtml: string = null
  private pixelWidth: string = null
  private originalWidth: string = null
  private pixelHeight: string = null
  private originalHeight: string = null
  private originalPosition: string = null

  constructor(private el: ElementRef) {}

  private glyphHtml(fontAwesomeGlyph: string, spin: boolean) {
    let toReturn = `
    <span style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);font-size:${this.glyphSize};">
      <i class="fa-solid ${fontAwesomeGlyph}${spin ? ' fa-spin' : ''}"></i>
    </span>
    `
    return toReturn
  }

  private busyHtml() {
    return this.glyphHtml('fa-spinner', true)
  }

  private doneHtml() {
    return this.glyphHtml('fa-check', false)
  }

  ngAfterViewChecked() {
    if (!this.initialized && this.el.nativeElement.offsetWidth > 0) {
      this.originalInnerHtml = this.el.nativeElement.innerHTML
      this.pixelWidth = this.el.nativeElement.offsetWidth
      this.originalWidth = this.el.nativeElement.style.width
      this.pixelHeight = this.el.nativeElement.offsetHeight
      this.originalHeight = this.el.nativeElement.style.height
      this.originalPosition = this.el.nativeElement.style.position
      this.initialized = true

      this.ngOnChanges()
    }
  }

  ngOnChanges() {
    // This function is invoked whenever one of the @Inputs change for this directive.
    // We use this event to compute the appropriate HTML content for the control to
    // indicate activity or doneness.

    if (!this.initialized) {
      // If the view has not been initialized yet, we cannot do anything.
      return
    }

    if (this.busy) {
      this.el.nativeElement.style.width = `${this.pixelWidth}px`
      this.el.nativeElement.style.height = `${this.pixelHeight}px`
      this.el.nativeElement.style.position = 'relative'
      this.el.nativeElement.innerHTML = this.busyHtml()
    } else if (this.done) {
      this.el.nativeElement.style.width = `${this.pixelWidth}px`
      this.el.nativeElement.style.height = `${this.pixelHeight}px`
      this.el.nativeElement.style.position = 'relative'
      this.el.nativeElement.innerHTML = this.doneHtml()
    } else {
      this.el.nativeElement.style.width = this.originalWidth
      this.el.nativeElement.style.height = this.originalHeight
      this.el.nativeElement.style.position = this.originalPosition
      this.el.nativeElement.innerHTML = this.originalInnerHtml
    }
  }
}
